import script from "./NkDevice.vue?vue&type=script&lang=ts&setup=true"
export * from "./NkDevice.vue?vue&type=script&lang=ts&setup=true"

import "./NkDevice.vue?vue&type=style&index=0&id=26ceab64&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26ceab64"]])

export default __exports__